import React from 'react'
import { Button } from '../../../components';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import useLoginModal from '../../login/useLoginModal';
import mixpanel from 'mixpanel-browser';


const Community = ({ eventData, is_community, community_link }) => {
  const { userData } = useSelector((state) => state.app);
  const navigate = useNavigate();
  const loginModal = useLoginModal();
  const joinCommunity =()=>{
    if (is_community && community_link) {
      mixpanel.track('Clicked_Community_Join', {
        'event_id': eventData?._id,
        'event_name': eventData?.name,
        'user_id': userData?._id,
        'community_Link': community_link,
        'page_url': window.location.href,
      });
      window.location.href = community_link;
    }
  }

  const handleJoinClick= () => {
    if (!userData?.email) {
      loginModal.onOpen();
      loginModal.callback.current = joinCommunity;
    } else {
      joinCommunity();
    }
  };
  return (
    <div className='flex flex-col gap-5 p-5 bg-grey-5 tems-center rounded-xl justify-between md:flex-row'>
      <div className='flex flex-col gap-4 items-start md:flex-row md:items-center'>
        <img src='assets/images/group.svg'/>
        <div className='heading-16'>
          Want to know who all are <br/> going to the event?
        </div> 
      </div>
      <Button
        type='primary-black'
        className='community-btn'
        onClick={handleJoinClick}><img src='assets/images/wp.svg' 
          alt='wp'/>Join the Community</Button>
    </div>
  )
}

export default Community;